<template>
  <div class="menubuilder" id="menubuilder">
    <div class="menubuilder__container">
      <LogoUpload></LogoUpload>
      <CoffeeSelector></CoffeeSelector>
      <CustomCoffeeSelector></CustomCoffeeSelector>
      <ExtrasSelector></ExtrasSelector>
      <TeaSelector></TeaSelector>
      <OtherSelector></OtherSelector>
      <CertificationSelector></CertificationSelector>
      <FinalForm @preview="togglePreviewPopup"></FinalForm>
    </div>

    <Modal title="Menu Preview" className="wide" :isOpen="previewPopupOpen" @toggle="togglePreviewPopup">
      <embed width='100%' style="min-height: calc(100vh - 200px)" height='100%' :src='iframedata'/>
    </Modal>
  </div>
</template>


<script>
  import axios from 'axios';
  import LogoUpload from './LogoUpload.vue';
  import CoffeeSelector from './CoffeeSelector.vue';
  import TeaSelector from './TeaSelector.vue';
  import CustomCoffeeSelector from './CustomCoffeeSelector.vue';
  import ExtrasSelector from './ExtrasSelector.vue';
  import OtherSelector from './OtherSelector.vue';
  import CertificationSelector from './CertificationSelector.vue';
  import FinalForm from './FinalForm.vue';
  import Modal from '../Utilities/Modal.vue';
  import pdfService from "../../services/pdf.service"

  export default {
  components: { LogoUpload, CoffeeSelector, TeaSelector, CustomCoffeeSelector, ExtrasSelector, OtherSelector, CertificationSelector, FinalForm, Modal },

    data: function () {
      return {
        coffees: this.$store.state.coffees,
        previewPopupOpen: false,
        fullState: this.$store.state,
        iframedata: "",
        wordPressId: 0,
        defaultExtra: "",
        defaultExtrasPrice: '',
        newProductPrice: '',
        hideOneSizeColumn: false

      };
    },
    watch: {
      something: {
        handler: async function() {
        }
      },
    },
    computed: {
    },
    props: [],
    methods: {

      togglePreviewPopup() {

        pdfService.createPDF(this.fullState, true)
        this.iframedata = pdfService.downloadAsDataUri()


        this.previewPopupOpen = ! this.previewPopupOpen;
        const body = jQuery("body");

        if(body.css("overflow-y") !== "hidden") {
          jQuery("body").css("overflow-y", "hidden").css("height", "100vh");
        } else {
          jQuery("body").css("overflow-y", "inherit").css("height", "inherit");
        }

      },

    },
    computed: {
    },
    async mounted() {

      // const { data } = await axios.get(`/wp-json/wp/v2/coffee`);
      // this.$store.setCoffees(data);

      // Let's get the wordpress id from the class name on the body.
      // It's a bad way to do it, but then again, we're working with WordPress.
      this.wordPressId = +document.querySelector("body").className.split(/\s+/)
                                  .filter(x => x.substr(0,8) === "page-id-")[0].substr(8);

      const pageData = (await axios.get(`/wp-json/wp/v2/pages/${this.wordPressId}`)).data;

      let store = this.$store;

      pageData.acf.available_coffees.map(x => store.addCustomCoffee(x.name, x.price, x.s_price, x.m_price, x.l_price, x.certifications))

      pageData.acf.available_teas.map(x => store.addTea(x.name, x.price, x.description))

      this.$store.setCoffees(pageData.acf.coffees);

      this.defaultExtra = pageData.acf.default_extra;
      this.defaultExtrasPrice = pageData.acf.default_extras_price;
      this.newProductPrice = pageData.acf.new_product_price;
      this.hideOneSizeColumn = pageData.acf.hide_one_size_column;
      this.extrasDefaultTitle = pageData.acf.extras_default_title;
      this.otherDefaultTitle = pageData.acf.other_default_title;

      this.$store.addExtra(pageData.acf.default_extra, pageData.acf.default_extras_price)

      if (typeof pageData.acf.extras_help_text !== 'undefined' && pageData.acf.extras_help_text != '') {
        this.$store.setExtrasHelpText(pageData.acf.extras_help_text)
      }

      if (typeof pageData.acf.other_help_text !== 'undefined' && pageData.acf.other_help_text != '') {
        this.$store.setOtherHelpText(pageData.acf.other_help_text)
      }

      if (typeof pageData.acf.extras_default_title !== 'undefined' && pageData.acf.extras_default_title !== '') {
        this.$store.setExtrasDefaultTitle(pageData.acf.extras_default_title)
      }

      if (typeof pageData.acf.other_default_title !== 'undefined' && pageData.acf.other_default_title !== '') {
        this.$store.setOtherDefaultTitle(pageData.acf.other_default_title)
      }

      this.$store.setHideOneSizeColumn(pageData.acf.hide_one_size_column)

      if (typeof pageData.acf.new_product_price !== 'undefined' && pageData.acf.new_product_price !== '') {
        this.$store.setNewProductPrice(pageData.acf.new_product_price)
      }

      this.$store.setTexts(pageData.acf.organic_text,
                           pageData.acf.fairtrade_text,
                           pageData.acf.rainforest_text,
                           pageData.acf.our_coffees_text,
                           pageData.acf.certifications_text)


    }
  }

</script>


<style lang="sass">
@import "../../../../styles/partials/variables"


.menubuilder
  padding: 150px 0
  background: $color-mb-background


  h3, h2
    color: var( --e-global-color-primary );
    font-family: var( --e-global-typography-primary-font-family ), Sans-serif;
    font-weight: var( --e-global-typography-primary-font-weight )!important;
  h3
    font-weight: 600!important
    text-transform: uppercase
    font-size: 25px!important

  h2
    font-size: 30px!important
    font-weight: 600!important
    margin-bottom: 0

  &__container
    background: $color-white
    width: 800px
    max-width: 100%
    margin: 0 auto
    padding: 50px

</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/components/MenuBuilder/MenuBuilder.vue